module.exports = {
      id: "outlook-agenda (1)-usage",
      viewBox: "0 0 1831.085 1703.335",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#outlook-agenda (1)",
      toString: function () {
        return this.url;
      }
    }